import React from 'react';
import {DatePicker} from 'components/antd';
import useSearchParams from '../../useSearchParams';
import moment from 'moment';

const MailTermFilter = () => {
  const {query, setQuery} = useSearchParams();
  const {mailTerm} = query;
  const {RangePicker} = DatePicker;
  const format = 'YYYY-MM-DD';

  return (
    <RangePicker
      format={format}
      placeholder={['開始日', '終了日']}
      value={
        mailTerm?.from && mailTerm?.to
          ? [moment(mailTerm.from, format), moment(mailTerm.to, format)]
          : null
      }
      onChange={(value) => {
        if (value) {
          setQuery({
            mailTerm: {
              from: value[0].format(format),
              to: value[1].format(format),
            },
          });
        } else {
          setQuery({
            mailTerm: null,
          });
        }
      }}
    />
  );
};

export default MailTermFilter;
